import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileTimePicker } from '@mui/x-date-pickers/MobileTimePicker';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import { IconButton } from '@mui/material';
import TextField from '@mui/material/TextField';

import { styled } from '@mui/system';
import { useState, useEffect } from 'react';

const OpenHoursContainer = styled('div')({
  margin: '10px 2px 0 0',
});

const OpenHoursTitle = styled('div')({
  width: '72px',
  height: '20px',
  '>p': {
    fontFamily: 'Fjalla One',
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '20px',
    color: 'rgba(113, 113, 113, 0.7)',
    margin: '0',
  },
});

const OpenHoursSetContainer = styled('div')({
  margin: '0 0 10px 8px',
  display: 'flex',
  height: '40px',
  alignItems: 'center',
});

const Days = styled('div')({
  width: '102px',
  height: '23px',
  '>p': {
    fontFamily: 'Fjalla One',
    fontWeight: '400',
    fontSize: '18px',
    lineHeight: '22.6px',
    margin: '7px 0 0 0',
  },
});

const OpenTimeContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  width: '70px',
  height: '40px',
  borderBottom: '2px solid #AA9178',
});

const TimeTitle = styled('div')({
  width: '50px',
  height: '13px',
  '>p': {
    fontFamily: 'Raleway',
    fontSize: '11px',
    fontWeight: '400',
    lineHeight: '13px',
    color: '#717171',
    margin: '0',
  },
});

const BusinessTimeProvider = styled(LocalizationProvider)({});

const BusinessTimePicker = styled(MobileTimePicker)({
  '.MuiOutlinedInput-input': {
    padding: '0 0 1px 2px',
  },
  '& input': {
    fontFamily: 'Fjalla One',
    fontWeight: '400',
    fontSize: '18px',
    lineHeight: '23px',
    color: '#000',
  },
  '& input::placeholder': {
    color: 'rgba(153, 152, 154, 0.7)',
  },
  '.MuiOutlinedInput-notchedOutline': {
    border: 0,
  },
});

const Line = styled('div')({
  height: '15px',
  width: '20px',
  borderBottom: '2px solid #000',
  margin: '0 27px 0 11px',
});

const SwitchBtn = styled(IconButton)({
  padding: '0',
  margin: '8px 0 0 16px',
});

const ClosedContainer = styled('div')({
  width: '198px',
  height: '40px',
  '>p': {
    fontFamily: 'Fjalla One',
    fontWeight: '400',
    fontSize: '18px',
    lineHeight: '22px',
  },
});

const DayOpen = (props) => {
  const [openTime, setOpenTime] = useState(null);
  const [closeTime, setCloseTime] = useState(null);

  const onOpenChange = (value) => {
    setOpenTime(value);
    updateDayData(props.data, 'openTime', value.format('h:mm A'));
    updateDayData(props.data, 'isClosed', false);
  };
  const onCloseChange = (value) => {
    setCloseTime(value);
    updateDayData(props.data, 'closeTime', value.format('h:mm A'));
    updateDayData(props.data, 'isClosed', false);
  };

  return (
    <OpenHoursSetContainer>
      <Days>
        <p>{props.day}</p>
      </Days>
      <OpenTimeContainer>
        <TimeTitle>
          <p>From</p>
        </TimeTitle>
        <BusinessTimeProvider dateAdapter={AdapterDayjs}>
          <BusinessTimePicker
            value={openTime}
            onChange={onOpenChange}
            renderInput={(params) => {
              return (
                <TextField
                  {...params}
                  inputProps={{
                    ...params.inputProps,
                    placeholder: '7:00 AM',
                  }}
                />
              );
            }}
          ></BusinessTimePicker>
        </BusinessTimeProvider>
      </OpenTimeContainer>
      <Line />
      <OpenTimeContainer>
        <TimeTitle>
          <p>To</p>
        </TimeTitle>
        <BusinessTimeProvider dateAdapter={AdapterDayjs}>
          <BusinessTimePicker
            value={closeTime}
            onChange={onCloseChange}
            renderInput={(params) => {
              return (
                <TextField
                  {...params}
                  inputProps={{
                    ...params.inputProps,
                    placeholder: '12:00 PM',
                  }}
                />
              );
            }}
          ></BusinessTimePicker>
        </BusinessTimeProvider>
      </OpenTimeContainer>
      <SwitchBtn onClick={props.press}>
        <SwapVertIcon />
      </SwitchBtn>
    </OpenHoursSetContainer>
  );
};

const DayClose = (props) => {
  useEffect(() => {
    updateDayData(props.data, 'isClosed', true);
  }, []);

  return (
    <OpenHoursSetContainer>
      <Days>
        <p>{props.day}</p>
      </Days>
      <ClosedContainer>
        <p>Closed</p>
      </ClosedContainer>
      <SwitchBtn onClick={props.press}>
        <SwapVertIcon />
      </SwitchBtn>
    </OpenHoursSetContainer>
  );
};

function updateDayData(data, field, value) {
  data[field] = value;
}

const TimeAction = ({ data }) => {
  const [isDayClosed, setIsDayClosed] = useState(false);
  const DayCloseBtn = () => {
    setIsDayClosed(!isDayClosed);
  };
  return (
    <>
      {isDayClosed ? (
        <DayClose press={DayCloseBtn} day={data.day} data={data} />
      ) : (
        <DayOpen press={DayCloseBtn} day={data.day} data={data} />
      )}
    </>
  );
};

const OpenHours = ({ data }) => {
  return (
    <OpenHoursContainer>
      <OpenHoursTitle>
        <p>Open hours</p>
      </OpenHoursTitle>
      {data.map((openData, index) => (
        <TimeAction data={openData} key={openData.day} />
      ))}
    </OpenHoursContainer>
  );
};

export default OpenHours;
